export default __webpack_public_path__ + "static/media/BastardGif1B.d23dd600.gif";